<!--
  랜덤 메세지 컴포넌트
  - TOTALSR-79231 정규집합 모바일 출결관리 개발 건
  - 입실/퇴실 상태에 따른 랜덤 메세지 노출
-->
<template>
  <p v-if="showRndMsg" class="text rnd_msg" v-html="rndMsg" />
</template>

<script>
export default {
  name: 'RandomMessage',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: QR출석체크 인사말 컴포넌트'
    }
  },
  props: {
    // 입실, 퇴실 구분(true: 입실)
    checkIn: {
      type: Boolean,
      default: true
    },
    // 랜덤 메세지 영역 노출 여부
    showRndMsg: {
      type: Boolean,
      default: false
    },
    // 랜덤 메세지 영역 애니메이션 적용 여부
    showAnimation: {
      type: Boolean,
      default: false
    },
    // 문장 끝에 이모지 사용 여부
    showEmoji: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 랜덤 메세지 (입실)
      rndMsgIn: [
        '오늘 하루 지식의 바다에서<br />함께 여행을 떠나볼까요?',
        '오늘도 지식의 씨앗을<br />함께 심어보기로 해요.',
        '한 걸음씩 성장하며,<br />무한 가능성을 활짝 ~! 얍!',
        '반갑습니다:D 힘찬 하루의<br />여정을 시작 해볼까요?',
        '오늘은 어제보다<br />멋진 하루 만들어보기!',
        '오늘도 웃음으로 가득한<br />하루가 되길 바랄게요',
        '새로운 하루! 새로운 시작!<br />오늘도 파이팅!',
        '당신이 만들어갈<br />오늘 하루가 기대됩니다',
        '오늘도 당신의 미소가<br />빛나길 바랄게요',
        '오늘 하루 당신의 잠재력을<br />발견해보는 건 어떨까요?',
        '새로운 출발!<br />힘차게 달려보자구요!',
        '웃음이 가득한<br />하루가 되길 바랍니다',
        '향하는 발걸음은 산뜻하게,<br />시작하는 하루는 상쾌하게!'
      ],
      // 랜덤 메세지 (퇴실)
      rndMsgOut: [
        '오늘이 좋은 하루로 남을 수 있도록<br />남은 시간 알차게 보내세요',
        '오늘 하루 멋진:)<br />학습여행을 마쳤습니다. 감사합니다.',
        '끊임없이 나아가는<br />멋!진! 당신을 응원합니다.',
        '휴식도 우리에겐 성장의 일부랍니다.<br />평온한 저녁시간 보내시길',
        '당신이 있어서<br />오늘도 아주 특별한 하루였어요!',
        '후회 없이 최선을 다한<br />하루가 되셨길 바랍니다',
        '오늘 하루 즐겁게<br />마무리 하시길 바랍니다',
        '오늘도 더 크게 성장한<br />하루가 되셨길 바랍니다',
        '당신의 하루가<br />티없이 맑은 하루였기를 바랄게요.'
      ],
      // 랜덤 처리된 최종 메세지
      rndMsg: '',
      greetingMsg: ''
    }
  },
  created () {
    this.selectGreetingMessage()
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.showRndMsg) {
        const headerTxt = document.querySelector('.mycheck_header .text.attendance_msg') // 입, 퇴실 메세지 영역
        const rndTxt = document.querySelector('.mycheck_header .text.rnd_msg') // 입, 퇴실에 따른 랜덤 메세지 영역
        // 입, 퇴실 구분에 따른 랜덤 메세지 배열값
        // const rndMsg = this.getRndMsg(this.checkIn ? this.rndMsgIn : this.rndMsgOut)
        // this.rndMsg = this.wrapTxtWithSpan(this.greetingMsg || rndMsg) // 출력할 랜덤 메세지

        // 입, 퇴실 메세지 영역 숨김
        if (headerTxt) {
          setTimeout(() => {
            headerTxt.classList.remove('in')
            headerTxt.classList.add('out')
          }, 3000)
        }

        // 랜덤 메세지 영역 노출
        if (rndTxt) {
          setTimeout(() => {
            rndTxt.classList.add('in')
          }, 3200)
        }
      }
    },
    selectGreetingMessage () {
      const params = {
        atdncType: this.checkIn ? 'enter' : 'exit',
        langCd: this.getUserLangCd()
      }
      this.$http.b2c.selectGreetingMessage(this, params).then( result => {
        if (result.data.status === 'OK') {
          this.greetingMsg = result.data.data.greetingMsg.name
        }
        const rndMsg = this.getRndMsg(this.checkIn ? this.rndMsgIn : this.rndMsgOut)
        this.rndMsg = this.wrapTxtWithSpan(this.greetingMsg || rndMsg) // 출력할 랜덤 메세지
      })
    },
    // 랜덤 이모지 픽커
    getRndEmoji () {
      const arrEmoji = [
        '&#128512;', // 😀
        '&#128513;', // 😁
        '&#128516;', // 😄
        '&#128522;', // 😊
        '&#129321;', // 🤩
        '&#129392;' // 🥰
      ]
      return this.getRndMsg(arrEmoji)
    },
    // 랜덤 메세지 노출
    getRndMsg (arrMsg) {
      const min = 0 // 배열의 최소값
      const max = arrMsg.length > 1 ? (arrMsg.length - 1) : 0 // 배열의 최대값
      const rndNum = max === 0 ? 0 : (Math.floor(Math.random() * (max - min + 1)) + min) // 최소, 최대값 사이의 랜덤값
      return arrMsg[rndNum] // 랜덤값 기준으로 배열 내 텍스트 반환
    },
    // 문자를 span 태그로 감싸기
    wrapTxtWithSpan (text) {
      const basicDelay = 4.5
      let idx = basicDelay
      let elClass = this.showAnimation ? 'bounce_txt bounce' : 'bounce_txt'
      let delayStyle
      // 랜덤 이모지
      const rndEmoji = this.getRndEmoji()
      // 문장 분리하여 span 태그로 감싸기(문장 내 태그, 공백문제 제외)
      const tmpText = text.replace(/(<\/?[^>]+>)|([^<>]+)/g, (match, p1, p2) => {
        // p1: HTML 태그에 매치
        // p2: 문자, 공백문자에 매치
        if (p1) {
          // HTML 태그는 그대로 반환
          return p1
        } else {
          // 공백문자는 '&nbsp;' 반환, 문자는 span 태그로 감싸서 반환
          const tmpResult = p2.split('').map(char => {
            if (char === ' ') {
              return '&nbsp;'
            } else {
              delayStyle = this.showAnimation ? `style="animation-delay:${idx}s"` : ''
              const el = `<span class="${elClass}" ${delayStyle}>${char}</span>`
              // idx += 0.1
              idx = +(Math.round((idx + 0.1) + 'e+1') + 'e-1')
              return el
            }
          }).join('')
          return tmpResult
        }
      })
      delayStyle = this.showAnimation ? `style="animation-delay:${idx}s"` : ''
      const result = this.showEmoji ? `${tmpText}&nbsp;<span class="${elClass}" ${delayStyle}>${rndEmoji}</span>` : `${tmpText}`
      return result
    }
  }
}
</script>

<style scoped>
.text.in {opacity:1;top:0;}
.text.rnd_msg {line-height:33px;opacity:0;position:absolute;top:50%;left:0;height:66px;transition:top 0.54s cubic-bezier(0, 0.55, 0.45, 1), opacity 0.2s ease-in;}
.text.rnd_msg /deep/ .bounce_txt {display:inline-block;line-height:28px;font-size:22px;color:#2D94F9;font-weight:700;letter-spacing:-.6px;}
.text.rnd_msg /deep/ .bounce_txt.bounce {animation:bounce .4s 4 alternate;}

@keyframes bounce {
  100% {
    transform: translateY(-3px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/attend/RandomMessage.vue